/**
 * RejectPOModal — captures the mandatory reason for cancelling a PO.
 * Issue #130 / #106. Calls reject_purchase_order via MCP.
 */

import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap';
import { rejectPurchaseOrder } from '../../services/purchaseOrderService';
import { toast } from '../../utils/toast';

const RejectPOModal = ({ show, onHide, purchase, onRejected }) => {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!show) return;
    setReason('');
    setError(null);
  }, [show]);

  const handleSubmit = async () => {
    setError(null);
    if (!reason.trim()) {
      setError('El motivo es requerido para rechazar/cancelar la PO.');
      return;
    }
    setSubmitting(true);
    const { error: err, data } = await rejectPurchaseOrder(purchase.id, reason.trim());
    setSubmitting(false);
    if (err) {
      setError(err.message || 'Error al rechazar');
      toast.error('Error al rechazar PO');
      return;
    }
    toast.success('PO cancelada');
    if (onRejected) onRejected(data);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-x-circle text-danger me-2"></i>
          Rechazar / Cancelar PO
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted small">
          Esta acción marca la PO como <strong>cancelada</strong>. El motivo se
          guarda en las notas de la PO y se notifica al creador.
        </p>
        <Form.Group className="mb-3">
          <Form.Label>
            Motivo <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Explica brevemente por qué se rechaza/cancela esta PO..."
            autoFocus
          />
        </Form.Group>
        {error && (
          <Alert variant="danger" className="mb-0">
            <i className="bi bi-exclamation-triangle me-2"></i>{error}
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={submitting}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={handleSubmit} disabled={submitting}>
          {submitting ? (
            <><Spinner size="sm" className="me-2" />Procesando...</>
          ) : (
            <><i className="bi bi-x-circle me-2"></i>Rechazar PO</>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RejectPOModal;
